module.exports = __webpack_public_path__ + "static/media/5-8.faad62e6.mp3";